import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { useBrandManager } from '@/hooks/useBrandManager';

export const useCurrentUserRole = () => {
  const { user } = useAuth();
  const { currentBrandId } = useBrandManager();

  const { data, isLoading } = useQuery({
    queryKey: ['current-user-role', user?.id, currentBrandId],
    queryFn: async () => {
      if (!user?.id || !currentBrandId) return null;
      const { data } = await supabase
        .from('user_brand_access')
        .select('custom_roles(name, color)')
        .eq('user_id', user.id)
        .eq('brand_id', currentBrandId)
        .maybeSingle();
      const role = data?.custom_roles as any;
      return { name: (role?.name as string) ?? null, color: (role?.color as string) ?? null };
    },
    enabled: !!user?.id && !!currentBrandId,
  });

  const roleName = data?.name ?? null;
  const roleColor = data?.color ?? null;

  return {
    roleName,
    roleColor,
    isLoading,
    is2y3xRole: (roleName ?? '').toLowerCase().includes('2y3x'),
  };
};
